import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'start.learning': {
    id: 'start.learning',
    defaultMessage: 'Start learning',
    description: 'Header text for logistration MFE pages',
  },
  'with.site.name': {
    id: 'with.site.name',
    defaultMessage: 'with {siteName}',
    description: 'Header text with site name for logistration MFE pages',
  },
  // authenticated user base component text
  'complete.your.profile.1': {
    id: 'complete.your.profile.1',
    defaultMessage: 'Complete',
    description: 'part of text "complete your profile"',
  },
  'complete.your.profile.2': {
    id: 'complete.your.profile.2',
    defaultMessage: 'your profile',
    description: 'part of text "complete your profile"',
  },
  'welcome.to.platform': {
    id: 'welcome.to.platform',
    defaultMessage: 'Welcome to {siteName}, {username}!',
    description: 'Welcome message that appears on progressive profile page',
  },
});

export default messages;
